export function toSnakeCase(input) {
  return input.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/)
      .map(s => s.toLowerCase()).join('_');
}